export enum ErrorExceptionFragmentsEnum {
  lic_exp = 'lic_exp',
  mac_err = 'mac_err',
  ag_exp = 'ag_exp',
  no_lic = 'no_lic',
}
